import { writable } from 'svelte/store';

export const BriefTitle = writable('');

